var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCharger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "charger"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3301_3662",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 65
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.5,
    width: 64,
    height: 64,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3301_3662)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "charger_2",
    d: "M30.1242 53.8242L43.4576 27.8242H34.1242V11.1576L20.7909 37.1576H30.1242V53.8242ZM31.9909 59.1575C28.302 59.1575 24.8353 58.4575 21.5909 57.0575C18.3464 55.6575 15.5242 53.7576 13.1242 51.3576C10.7242 48.9576 8.82422 46.1353 7.42422 42.8909C6.02422 39.6464 5.32422 36.1798 5.32422 32.4909C5.32422 28.802 6.02422 25.3353 7.42422 22.0909C8.82422 18.8464 10.7242 16.0242 13.1242 13.6242C15.5242 11.2242 18.3464 9.32422 21.5909 7.92422C24.8353 6.52422 28.302 5.82422 31.9909 5.82422C35.6798 5.82422 39.1464 6.52422 42.3909 7.92422C45.6353 9.32422 48.4576 11.2242 50.8576 13.6242C53.2576 16.0242 55.1575 18.8464 56.5575 22.0909C57.9575 25.3353 58.6575 28.802 58.6575 32.4909C58.6575 36.1798 57.9575 39.6464 56.5575 42.8909C55.1575 46.1353 53.2576 48.9576 50.8576 51.3576C48.4576 53.7576 45.6353 55.6575 42.3909 57.0575C39.1464 58.4575 35.6798 59.1575 31.9909 59.1575Z",
    fill: "#2A904F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharger);
export default __webpack_public_path__ + "static/media/charger.3a27f18ad89443dadfa587c9cc8cda98.svg";
export { ForwardRef as ReactComponent };